import PropTypes from 'prop-types';
import { DefaultLanguage, FORMATTED_DATE, JOURNEY_STEP_TYPES, MEETING_TYPE } from '../../../../constants/Constants';
import clsx from 'clsx';
import moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormResponse from './AnswerStep/FormResponse';
import { Localize } from '../Localize';
import PublicVariables from '../../../../constants/PublicVariables';
import { getJourneyWordDoc, getJourneyWordDocReset } from '../../../../actions/sessionDetailAction';
import { getFileNameFromContentDisposition, handleErrorMsgToastVisiblity } from '../../../../shared/utility';
import CustomToast from '../../../UI/customToast';

const ResponsesTab = (props) => {

    const { sessionType, journeySessionDetails, imageData, videoData, fancyRef, meetingID } = props;

    const [formResponseData, setFormResponseData] = useState([]);
    const [localisedValues, setLocalisedValues] = useState({});
    const [isWordDocDownloading, setIsWordDocDownloading] = useState(false);

    const dispatch = useDispatch();
    const { language } = useSelector((state) => state)
    const getJourneyWordDocData = useSelector((state) => state.sessionDetail?.getJourneyWordDocData)
    const getJourneyWordDocError = useSelector((state) => state.sessionDetail?.getJourneyWordDocError)
    const lang = PublicVariables.currentLanguage?.toLowerCase()

    useEffect(() => {
        const curLang = language.selectedlanguage;
        setLocalisedValues(Localize[curLang.id]);
    }, [language.selectedlanguage]);


    useEffect(() => {
        if (journeySessionDetails?.journeyDetail && (imageData || videoData)) {
            const jsonParseData = JSON.parse(journeySessionDetails?.journeyDetail?.formResponse);
            const finalResult = [];
            for (let i = 0; i < jsonParseData.answer.length; i++) {
                const answerItem = jsonParseData.answer[i];
                // Find corresponding question
                const questionItem = jsonParseData.data.find((q) => q.id === answerItem.id);

                // Find corresponding image
                let imageItem, videoItem
                if (questionItem.type === JOURNEY_STEP_TYPES.GPS_LOCATION && imageData.length > 0) {
                    imageItem = imageData.find((img) => img?.fileName === answerItem.answer[0]?.fileName);
                }
                if (questionItem.type === JOURNEY_STEP_TYPES.VIDEO && videoData.length > 0) {
                    videoItem = videoData.find((img) => img?.fileName === answerItem.answer[0]?.fileName);
                }
                if (questionItem.type === JOURNEY_STEP_TYPES.IMAGE && imageData.length > 0) {
                    imageItem = answerItem.answer.map((file) => {
                        return imageData.find((img) => img?.fileName === file?.fileName);
                    })
                }

                // Create a new object with the merged details
                const mergedItem = {
                    id: answerItem.id,
                    data: questionItem,
                    answer: answerItem.answer
                };
                if (imageItem) {
                    mergedItem.image = imageItem;
                }
                if (videoItem) {
                    mergedItem.video = videoItem;
                }
                
                // Add the merged item to the result array
                finalResult.push(mergedItem);
            }
            // Update the state once with the final data
            console.log('______finalResult_____', finalResult)
            setFormResponseData(finalResult);
        }
    }, [journeySessionDetails?.journeyDetail, imageData, videoData]);


    useEffect(() => {
        if (!isWordDocDownloading) return;
        if (!getJourneyWordDocData) return;
        const filename = getFileNameFromContentDisposition(getJourneyWordDocData.contentDisposition);
        saveAs(getJourneyWordDocData.fileString, filename);
        CustomToast.success(localisedValues["successfully_downloaded"]);
        setIsWordDocDownloading(false);
        /* The report is on disk now, so let go of the blob instead of holding it in the store for
           the rest of the visit. The guard above stops this re-entering the effect. */
        dispatch(getJourneyWordDocReset());
    }, [getJourneyWordDocData]);

    useEffect(() => {
        if (getJourneyWordDocError) {
            setIsWordDocDownloading(false);
            handleErrorMsgToastVisiblity(localisedValues["download_failed"]);
            dispatch(getJourneyWordDocReset());
        }
    }, [getJourneyWordDocError]);

    const downloadWordDoc = () => {
        if (!isWordDocDownloading) {
            setIsWordDocDownloading(true);
            const tempTimezone = moment.tz.guess();
            const localTimezone = moment.tz(tempTimezone).zoneAbbr();
            const offSet = moment.tz(moment.utc(), tempTimezone).utcOffset();
            const request = {
                sessionId: meetingID || journeySessionDetails?.session?.sessionId,
                timeZone: localTimezone,
                offSet: offSet
            };
            dispatch(getJourneyWordDoc(request));
            CustomToast.info(localisedValues["downloading"]);
        }
    }

    const goToStepButtonActionName = (btnName, btnKey, id, localisedValues) => {
        let val = formResponseData?.find(element => element?.id === id);
        if (btnKey === val.answer.go_to[0]) {
            return btnName
        } else if (val.answer.redirect_to.includes(btnKey)) {
            return localisedValues["viewed"]
        } else {
            return btnName
        }
    };

    const addTitleOfRedirectionButton = (btnName, btnValue) => {
        if (btnName === "skip") {
            if (btnValue === "-1") {
                return "Submit (Last step)"
            } else if (btnValue === "-2") {
                return "Next Step"
            } else {
                let val = formResponseData.find(element => element.id === btnValue);
                if (val?.data.title[language.selectedlanguage.id]) {
                    return val?.data.title[language.selectedlanguage.id];
                } else if (val?.data.title[DefaultLanguage]) {
                    return val?.data.title[DefaultLanguage];
                } else {
                    return val?.data.title[DefaultLanguage];
                }
            }
        } else if (btnName === "url") {
            return btnValue;
        }
    };

    return (
        <>
            {journeySessionDetails && <div className={clsx("tab-pane fade", sessionType === MEETING_TYPE.JOURNEY && "show active")} id="session-responses" role="tabpanel" aria-labelledby="session-responses-tab" tabIndex={0}>
                <div className="form-response custom-scroll-div">
                    <div className="form-response-head">
                        <div className="form-response-head-title">
                            <span className="title">{localisedValues["journey_label"]}: </span>
                            <span className="info">{journeySessionDetails?.journeyDetail?.name}</span>
                        </div>
                        <div className="form-response-head-right">
                            <button type="button"
                                className="btn border-round btn-with-icon form-response-head-download-btn"
                                disabled={isWordDocDownloading}
                                onClick={downloadWordDoc}
                                data-testid="downloadJourneyWordBtn">
                                <span className="left-icon icon-word-doc" aria-hidden="true"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
                                <span className="btn-text">{localisedValues["download_report"]}</span>
                                <span className="btn-cap" aria-hidden="true">
                                    {isWordDocDownloading
                                        ? <span className="for-icon icon-loader spin"></span>
                                        : <span className="icon-download"></span>}
                                </span>
                            </button>
                            <div className="form-response-head-date">
                                <span className="title">{localisedValues["submitted_on"]} </span>
                                <span className="info">{moment.utc(journeySessionDetails?.journeyDetail?.formSubmittedAt)?.locale(lang)?.format(FORMATTED_DATE)}</span>
                            </div>
                        </div>
                    </div>
                    {/* WCAG 2.1.1 (W-15 axe rule scrollable-region-focusable):
                        scrollable wrapper must be keyboard-focusable so Safari users
                        can scroll it with arrow keys. tabIndex on a non-interactive
                        scroll wrapper is the exact remediation axe prescribes. */}
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
                    <div className="form-response-body custom-scroll-div" tabIndex={0}>
                        <div className="form-response-list">
                            {formResponseData?.map((data, index) => (
                                <FormResponse
                                    fancyRef={fancyRef}
                                    key={index}
                                    answerObj={data?.answer}
                                    answerObjID={data?.id}
                                    dataObj={data.data}
                                    imageObj={data?.image}
                                    videoObj={data?.video}
                                    index={index}
                                    language={language}
                                    localisedValues={localisedValues}
                                    goToStepButtonActionName={goToStepButtonActionName}
                                    addTitleOfRedirectionButton={addTitleOfRedirectionButton}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    );
}

ResponsesTab.propTypes = {
  sessionType: PropTypes.number,
  journeySessionDetails: PropTypes.object,
  imageData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  videoData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  fancyRef: PropTypes.object,
  meetingID: PropTypes.string,
};

export default ResponsesTab;